import { Record, Union } from "../../fable_modules/fable-library.3.7.9/Types.js";
import { array_type, bool_type, list_type, class_type, string_type, record_type, option_type, int32_type, union_type } from "../../fable_modules/fable-library.3.7.9/Reflection.js";
import { isNullOrWhiteSpace, split, join } from "../../fable_modules/fable-library.3.7.9/String.js";
import { updateAt, append as append_1, tail, fold, head, map as map_3, sort } from "../../fable_modules/fable-library.3.7.9/Array.js";
import { ofList as ofList_1, ofArray as ofArray_1, empty as empty_1, singleton, FSharpSet__Add, FSharpSet__get_MinimumElement, FSharpSet__get_Count, FSharpSet__get_IsEmpty, toList, toArray } from "../../fable_modules/fable-library.3.7.9/Set.js";
import { equals, int32ToString, compare, comparePrimitives } from "../../fable_modules/fable-library.3.7.9/Util.js";
import { last, item, iterate, exists, findIndex, tail as tail_1, head as head_1, replicate, singleton as singleton_1, append, ofArray, isEmpty, filter, length, choose, empty, sort as sort_1, map } from "../../fable_modules/fable-library.3.7.9/List.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.9/Option.js";
import { SearchParams, Query as Query_1, StringUtils_replace } from "../../Shared/Shared.js";
import { map as map_2, delay, toList as toList_1 } from "../../fable_modules/fable-library.3.7.9/Seq.js";
import { create, split as split_1, matches, isMatch, match } from "../../fable_modules/fable-library.3.7.9/RegExp.js";
import { parse } from "../../fable_modules/fable-library.3.7.9/Int32.js";
import { FSharpMap__get_Item, FSharpMap__ContainsKey, ofList } from "../../fable_modules/fable-library.3.7.9/Map.js";
import { rangeDouble } from "../../fable_modules/fable-library.3.7.9/Range.js";
import { LoadedCorpusModel, Search as Search_1, Corpus__get_CwbAttributeMenu, Corpus__get_SharedInfo } from "./Model.js";

export class MinMax extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Min", "Max"];
    }
}

export function MinMax$reflection() {
    return union_type("CwbExtended.MinMax", [], MinMax, () => [[], []]);
}

export class Interval extends Record {
    constructor(Min, Max) {
        super();
        this.Min = Min;
        this.Max = Max;
    }
}

export function Interval$reflection() {
    return record_type("CwbExtended.Interval", [], Interval, () => [["Min", option_type(int32_type)], ["Max", option_type(int32_type)]]);
}

export class AttrOperator extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Equals", "NotEquals", "Contains", "NotContains"];
    }
}

export function AttrOperator$reflection() {
    return union_type("CwbExtended.AttrOperator", [], AttrOperator, () => [[], [], [], []]);
}

export function AttrOperator_OfString_Z721C83C5(s) {
    switch (s) {
        case "=": {
            return new AttrOperator(0);
        }
        case "!=": {
            return new AttrOperator(1);
        }
        case "%contains%": {
            return new AttrOperator(2);
        }
        case "%not%contains%": {
            return new AttrOperator(2);
        }
        default: {
            throw (new Error(`Unrecognized operator: ${s}`));
        }
    }
}

export function AttrOperator__ToOperatorString(this$) {
    switch (this$.tag) {
        case 1: {
            return "!=";
        }
        case 2: {
            return "%contains%";
        }
        case 3: {
            return "%not%contains%";
        }
        default: {
            return "=";
        }
    }
}

export class ExtraForm extends Record {
    constructor(Attr$, Operator, Values) {
        super();
        this.Attr = Attr$;
        this.Operator = Operator;
        this.Values = Values;
    }
}

export function ExtraForm$reflection() {
    return record_type("CwbExtended.ExtraForm", [], ExtraForm, () => [["Attr", string_type], ["Operator", AttrOperator$reflection()], ["Values", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export class Subcategory extends Record {
    constructor(Attr$, Operator, Values) {
        super();
        this.Attr = Attr$;
        this.Operator = Operator;
        this.Values = Values;
    }
}

export function Subcategory$reflection() {
    return record_type("CwbExtended.Subcategory", [], Subcategory, () => [["Attr", string_type], ["Operator", AttrOperator$reflection()], ["Values", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export function Subcategory__ToCqp(this$) {
    const valueStr = join("|", sort(toArray(this$.Values), {
        Compare: comparePrimitives,
    }));
    return `${this$.Attr}${AttrOperator__ToOperatorString(this$.Operator)}"${valueStr}"`;
}

export class MainCategory extends Record {
    constructor(Attr$, Operator, Value, Subcategories) {
        super();
        this.Attr = Attr$;
        this.Operator = Operator;
        this.Value = Value;
        this.Subcategories = Subcategories;
    }
}

export function MainCategory$reflection() {
    return record_type("CwbExtended.MainCategory", [], MainCategory, () => [["Attr", string_type], ["Operator", AttrOperator$reflection()], ["Value", string_type], ["Subcategories", option_type(class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Subcategory$reflection()]))]]);
}

export function MainCategory__ToCqp(this$) {
    const mainExpr = `${this$.Attr}${AttrOperator__ToOperatorString(this$.Operator)}"${this$.Value}"`;
    let expressions;
    const matchValue = this$.Subcategories;
    if (matchValue == null) {
        expressions = mainExpr;
    }
    else {
        const subcatExpressions = join(" \u0026 ", map(Subcategory__ToCqp, sort_1(toList(matchValue), {
            Compare: compare,
        })));
        expressions = (`${mainExpr} & ${subcatExpressions}`);
    }
    return `(${expressions})`;
}

export class QueryProperty extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["IsLemma", "IsPhonetic", "IsOriginal", "IsStart", "IsEnd", "IsMiddle", "IsInitial", "IsFinal"];
    }
}

export function QueryProperty$reflection() {
    return union_type("CwbExtended.QueryProperty", [], QueryProperty, () => [[], [], [], [], [], [], [], []]);
}

export class QueryTerm extends Record {
    constructor(MainStringValue, ExtraForms, IsLemma, IsPhonetic, IsOriginal, IsStart, IsEnd, IsMiddle, IsInitial, IsFinal, CategorySections, PrecedingInterval) {
        super();
        this.MainStringValue = MainStringValue;
        this.ExtraForms = ExtraForms;
        this.IsLemma = IsLemma;
        this.IsPhonetic = IsPhonetic;
        this.IsOriginal = IsOriginal;
        this.IsStart = IsStart;
        this.IsEnd = IsEnd;
        this.IsMiddle = IsMiddle;
        this.IsInitial = IsInitial;
        this.IsFinal = IsFinal;
        this.CategorySections = CategorySections;
        this.PrecedingInterval = PrecedingInterval;
    }
}

export function QueryTerm$reflection() {
    return record_type("CwbExtended.QueryTerm", [], QueryTerm, () => [["MainStringValue", option_type(string_type)], ["ExtraForms", list_type(ExtraForm$reflection())], ["IsLemma", bool_type], ["IsPhonetic", bool_type], ["IsOriginal", bool_type], ["IsStart", bool_type], ["IsEnd", bool_type], ["IsMiddle", bool_type], ["IsInitial", bool_type], ["IsFinal", bool_type], ["CategorySections", list_type(class_type("Microsoft.FSharp.Collections.FSharpSet`1", [MainCategory$reflection()]))], ["PrecedingInterval", option_type(Interval$reflection())]]);
}

export function QueryTerm_get_Default() {
    return new QueryTerm(void 0, empty(), false, false, false, false, false, false, false, false, empty(), void 0);
}

export function QueryTerm__ToCqp_Z721C83C5(this$, sTag) {
    let matchValue_1, mainAttr, caseInsensitiveStr, processedForm, f, nonEmptyCategorySections, s_1;
    let intervalString;
    const matchValue = this$.PrecedingInterval;
    if (matchValue == null) {
        intervalString = "";
    }
    else {
        const interval = matchValue;
        const min = defaultArg(map_1(int32ToString, interval.Min), "");
        const max = defaultArg(map_1(int32ToString, interval.Max), "");
        intervalString = (((min !== "") ? true : (max !== "")) ? (`[]{${min},${max}} `) : "");
    }
    let forms_1;
    const s_2 = join(" \u0026 ", choose((x_1) => x_1, ofArray([(matchValue_1 = this$.MainStringValue, (matchValue_1 == null) ? (void 0) : ((mainAttr = (this$.IsLemma ? "lemma" : (this$.IsPhonetic ? "phon" : (this$.IsOriginal ? "orig" : "word"))), (caseInsensitiveStr = (this$.IsPhonetic ? "" : " %c"), (processedForm = ((f = StringUtils_replace("[\\.\\*\\+\\?\\^\\$\\{\\}\\(\\)\\|\\[\\]\\\\]", "\\$\u0026", matchValue_1), this$.IsStart ? (`${f}.*`) : (this$.IsEnd ? (`.*${f}`) : (this$.IsMiddle ? (`.*${f}.*`) : f)))), `${mainAttr}="${processedForm}"${caseInsensitiveStr}`))))), (length(this$.ExtraForms) > 0) ? join(" \u0026 ", toList_1(delay(() => map_2((forms) => {
        const values = join("|", sort(toArray(forms.Values), {
            Compare: comparePrimitives,
        }));
        return `${forms.Attr}${AttrOperator__ToOperatorString(forms.Operator)}"${values}"`;
    }, this$.ExtraForms)))) : (void 0), (nonEmptyCategorySections = filter((sectionCategories) => (!FSharpSet__get_IsEmpty(sectionCategories)), this$.CategorySections), isEmpty(nonEmptyCategorySections) ? (void 0) : ((s_1 = join(" \u0026 ", toList_1(delay(() => map_2((categorySection) => {
        let s;
        const strings_2 = toList_1(delay(() => map_2(MainCategory__ToCqp, categorySection)));
        s = join(((FSharpSet__get_Count(categorySection) > 0) && equals(FSharpSet__get_MinimumElement(categorySection).Operator, new AttrOperator(1))) ? " \u0026 " : " | ", strings_2);
        return `(${s})`;
    }, nonEmptyCategorySections)))), `(${s_1})`)))])));
    forms_1 = (this$.IsInitial ? (`<${sTag}>[${s_2}]`) : (this$.IsFinal ? (`[${s_2}]</${sTag}>`) : (`[${s_2}]`)));
    return `${intervalString}${forms_1}`;
}

export function addOrRemoveExtraForms(term, attrName, operator, attrValue) {
    let foundForms = false;
    const extraFormsList = map((forms) => {
        if (forms.Attr === attrName) {
            foundForms = true;
            return new ExtraForm(forms.Attr, forms.Operator, FSharpSet__Add(forms.Values, attrValue));
        }
        else {
            return forms;
        }
    }, term.ExtraForms);
    if (foundForms) {
        return extraFormsList;
    }
    else {
        return append(extraFormsList, singleton_1(new ExtraForm(attrName, operator, singleton(attrValue, {
            Compare: comparePrimitives,
        }))));
    }
}

export function handleInterval(intervalStr) {
    let min;
    const m = match(/(\d+),/g, intervalStr);
    min = ((m != null) ? parse(m[1] || "", 511, false, 32) : (void 0));
    let max;
    const m_1 = match(/,(\d+)/g, intervalStr);
    max = ((m_1 != null) ? parse(m_1[1] || "", 511, false, 32) : (void 0));
    if ((min != null) ? true : (max != null)) {
        return new Interval(min, max);
    }
    else {
        return void 0;
    }
}

export function handleQuotedOrEmptyTerm(termStr, interval, maybeCwbAttributeMenu) {
    const categorySections = (maybeCwbAttributeMenu == null) ? empty() : replicate(length(maybeCwbAttributeMenu), empty_1({
        Compare: compare,
    }));
    if (termStr.length > 2) {
        const form = termStr.slice(1, (termStr.length - 2) + 1);
        const isStart = isMatch(/.+\.\*$/g, form);
        const isEnd = isMatch(/^\.\*.+/g, form);
        const isMiddle = isStart && isEnd;
        const inputRecord = QueryTerm_get_Default();
        return new QueryTerm(form, inputRecord.ExtraForms, inputRecord.IsLemma, inputRecord.IsPhonetic, inputRecord.IsOriginal, isMiddle ? false : isStart, isMiddle ? false : isEnd, isMiddle, inputRecord.IsInitial, inputRecord.IsFinal, categorySections, interval);
    }
    else {
        const inputRecord_1 = QueryTerm_get_Default();
        return new QueryTerm(inputRecord_1.MainStringValue, inputRecord_1.ExtraForms, inputRecord_1.IsLemma, inputRecord_1.IsPhonetic, inputRecord_1.IsOriginal, inputRecord_1.IsStart, inputRecord_1.IsEnd, inputRecord_1.IsMiddle, inputRecord_1.IsInitial, inputRecord_1.IsFinal, categorySections, interval);
    }
}

export function handleAttributeValue(inputStr, interval, isSegmentInitial, isSegmentFinal, maybeCwbAttributeMenu) {
    let tupledArg, name, value, isLemma, isPhon, isOrig, isStart, isEnd, isMiddle, inputRecord, cwbAttributeMenu, m_2, categorySections, sectionsByAttributeMenuIndex;
    const processOtherForms = (term, tupledArg_1) => (new QueryTerm(term.MainStringValue, addOrRemoveExtraForms(term, tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]), term.IsLemma, term.IsPhonetic, term.IsOriginal, term.IsStart, term.IsEnd, term.IsMiddle, term.IsInitial, term.IsFinal, term.CategorySections, term.PrecedingInterval));
    let processForms;
    let termWithNonCategories;
    let maybeNonCatStr;
    if (inputStr.indexOf("(") >= 0) {
        const m = match(/^([^\(]+)&/g, inputStr);
        maybeNonCatStr = ((m != null) ? (m[1] || "") : (void 0));
    }
    else {
        maybeNonCatStr = inputStr;
    }
    if (maybeNonCatStr == null) {
        termWithNonCategories = QueryTerm_get_Default();
    }
    else {
        const attrValuePairs = map_3((arg_2) => {
            const m_1 = match(/(.+?)(!?=|%(?:not%)?contains%)"(.+)"/g, StringUtils_replace("%c", "", arg_2));
            return [m_1[1] || "", AttrOperator_OfString_Z721C83C5(m_1[2] || ""), m_1[3] || ""];
        }, split(maybeNonCatStr, ["\u0026"], null, 0));
        const h = head(attrValuePairs);
        termWithNonCategories = ((h[1].tag === 0) ? fold(processOtherForms, (tupledArg = h, (name = tupledArg[0], (value = tupledArg[2], (isLemma = (name === "lemma"), (isPhon = (name === "phon"), (isOrig = (name === "orig"), (isStart = isMatch(/.+\.\*$/g, value), (isEnd = isMatch(/^\.\*.+/g, value), (isMiddle = (isStart && isEnd), (inputRecord = QueryTerm_get_Default(), new QueryTerm(StringUtils_replace("(.+?)(?:\\.\\*)$", "$1", StringUtils_replace("^(?:\\.\\*)?(.+?)", "$1", StringUtils_replace("\\\\(.)", "$1", value))), inputRecord.ExtraForms, isLemma, isPhon, isOrig, isMiddle ? false : isStart, isMiddle ? false : isEnd, isMiddle, inputRecord.IsInitial, inputRecord.IsFinal, inputRecord.CategorySections, inputRecord.PrecedingInterval))))))))))), tail(attrValuePairs)) : fold(processOtherForms, QueryTerm_get_Default(), attrValuePairs));
    }
    processForms = (new QueryTerm(termWithNonCategories.MainStringValue, termWithNonCategories.ExtraForms, termWithNonCategories.IsLemma, termWithNonCategories.IsPhonetic, termWithNonCategories.IsOriginal, termWithNonCategories.IsStart, termWithNonCategories.IsEnd, termWithNonCategories.IsMiddle, termWithNonCategories.IsInitial, termWithNonCategories.IsFinal, (maybeCwbAttributeMenu == null) ? empty() : ((cwbAttributeMenu = maybeCwbAttributeMenu, (m_2 = match(/\((.+)\)/g, inputStr), (m_2 != null) ? ((categorySections = matches(/\(\((.+?)\)\)/g, m_2[1] || ""), (sectionsByAttributeMenuIndex = ofList(toList_1(delay(() => map_2((categorySection) => {
        const categoryStrings = split_1(categorySection[0] || "", "\\)[\\|\\\u0026]\\(");
        const categories = toList_1(delay(() => map_2((category) => {
            let matchValue;
            const attributeValuePairs = toList_1(delay(() => map_2((pair) => (new Subcategory(pair[1] || "", AttrOperator_OfString_Z721C83C5(pair[2] || ""), ofArray_1(split(pair[3] || "", ["|"], null, 0), {
                Compare: comparePrimitives,
            }))), matches(/(\w+)(!?=|%(?:not%)?contains%)"(.+?)"/g, category))));
            const firstPair = head_1(attributeValuePairs);
            return new MainCategory(firstPair.Attr, firstPair.Operator, ((FSharpSet__get_Count(firstPair.Values) !== 1) ? (() => {
                throw (new Error(`Main category should not have pipe in value: ${firstPair.Values}`));
            })() : (void 0), FSharpSet__get_MinimumElement(firstPair.Values)), (matchValue = tail_1(attributeValuePairs), isEmpty(matchValue) ? (void 0) : ofList_1(matchValue, {
                Compare: compare,
            })));
        }, categoryStrings)));
        const firstCategory = head_1(categories);
        return [findIndex((menuSection) => exists((_arg1) => {
            if (_arg1[0].Code === firstCategory.Attr) {
                return _arg1[1] === firstCategory.Value;
            }
            else {
                return false;
            }
        }, menuSection.Values), cwbAttributeMenu), ofList_1(categories, {
            Compare: compare,
        })];
    }, categorySections)))), toList_1(delay(() => map_2((i) => (FSharpMap__ContainsKey(sectionsByAttributeMenuIndex, i) ? FSharpMap__get_Item(sectionsByAttributeMenuIndex, i) : empty_1({
        Compare: compare,
    })), rangeDouble(0, 1, length(cwbAttributeMenu) - 1))))))) : replicate(length(cwbAttributeMenu), empty_1({
        Compare: compare,
    }))))), termWithNonCategories.PrecedingInterval));
    return new QueryTerm(processForms.MainStringValue, processForms.ExtraForms, processForms.IsLemma, processForms.IsPhonetic, processForms.IsOriginal, processForms.IsStart, processForms.IsEnd, processForms.IsMiddle, isSegmentInitial, isSegmentFinal, processForms.CategorySections, interval);
}

export class Query extends Record {
    constructor(Terms) {
        super();
        this.Terms = Terms;
    }
}

export function Query$reflection() {
    return record_type("CwbExtended.Query", [], Query, () => [["Terms", array_type(QueryTerm$reflection())]]);
}

export function Query_get_Default() {
    return new Query([]);
}

export function Query_STag_Z1E3D7454(corpus) {
    const matchValue = Corpus__get_SharedInfo(corpus).Modality;
    if (matchValue.tag === 1) {
        return "s";
    }
    else {
        return "who";
    }
}

export function Query_OfCqp_Z680882E9(corpus, cqpQuery) {
    const sTag = Query_STag_Z1E3D7454(corpus);
    const intervalRx = "\\[\\]\\{(.+?)\\}";
    const attributeValueRx = `(?:<${sTag}>)?\\\[(.+?)\\\](?:</${sTag}>)?`;
    const quotedOrEmptyTermRx = "\".*?\"|\\[\\]";
    const termsRegex = `${intervalRx}|${quotedOrEmptyTermRx}|${attributeValueRx}`;
    const s = StringUtils_replace("\\s+", "", cqpQuery);
    let terms = [];
    let latestInterval = void 0;
    iterate((tupledArg) => {
        const termStr = tupledArg[0];
        const groups_1 = tupledArg[1];
        if (isMatch(create(intervalRx), termStr)) {
            latestInterval = handleInterval(item(1, groups_1));
        }
        else if (isMatch(create(attributeValueRx), termStr)) {
            const isSegmentInitial = isMatch(create(`<${sTag}>`), termStr);
            const isSegmentFinal = isMatch(create(`</${sTag}>`), termStr);
            const term = handleAttributeValue(last(groups_1), latestInterval, isSegmentInitial, isSegmentFinal, Corpus__get_CwbAttributeMenu(corpus));
            terms = append_1(terms, [term]);
            latestInterval = (void 0);
        }
        else if (isMatch(create(quotedOrEmptyTermRx), termStr)) {
            const term_1 = handleQuotedOrEmptyTerm(termStr, latestInterval, Corpus__get_CwbAttributeMenu(corpus));
            terms = append_1(terms, [term_1]);
            latestInterval = (void 0);
        }
    }, isNullOrWhiteSpace(s) ? singleton_1(["[]", empty()]) : toList_1(delay(() => map_2((m) => {
        const groups = toList_1(delay(() => map_2((group) => (group || ""), m)));
        return [m[0], groups];
    }, matches(create(termsRegex), s)))));
    return new Query(terms);
}

export function Query__ToCqp_Z1E3D7454(this$, corpus) {
    return join(" ", map_3((term) => QueryTerm__ToCqp_Z721C83C5(term, Query_STag_Z1E3D7454(corpus)), this$.Terms));
}

export function updateQuery(model, query, queryIndex, newQueryTerms) {
    let inputRecord_2, inputRecord;
    const newQueryCqp = Query__ToCqp_Z1E3D7454(new Query(newQueryTerms), model.Corpus);
    return new LoadedCorpusModel(model.Corpus, model.FetchedMetadataValues, model.FetchedMinAndMax, model.FetchedTextMetadata, model.GeoDistribution, model.IsMetadataGeoMapOpen, model.IsNarrowWindow, model.IsSelectionTableOpen, model.IntervalCategoryModes, model.NumSelectedTexts, model.NumSelectedTokens, model.OpenMetadataCategoryCode, new Search_1(model.Search.Interface, (inputRecord_2 = model.Search.Params, new SearchParams(inputRecord_2.ContextSize, inputRecord_2.CorpusCode, inputRecord_2.CpuCounts, inputRecord_2.End, inputRecord_2.LastCount, inputRecord_2.MetadataSelection, inputRecord_2.NumRandomHits, inputRecord_2.PageSize, updateAt(queryIndex, (inputRecord = model.Search.Params.Queries[queryIndex], new Query_1(inputRecord.HasFinalSpace, inputRecord.LanguageCode, newQueryCqp)), model.Search.Params.Queries), inputRecord_2.RandomHitsSeed, inputRecord_2.SearchId, inputRecord_2.SortKey, inputRecord_2.Start, inputRecord_2.Step))), model.ShouldShowMetadataMenu, model.ShouldShowQuickView, model.SelectionTablePageNumber, model.SelectionTableSort, model.Substate, model.TextSelectionInfo, model.TextIdInQuickView, model.QuickViewMetadata);
}

export function updateQueryTerm(model, query, queryIndex, newTerm, termIndex) {
    return updateQuery(model, query, queryIndex, updateAt(termIndex, newTerm, query.Terms));
}

